import {
  Routes,
  Route,
  Navigate
} from "react-router-dom";

import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logPageView } from '../utlis/analytics';

import About from './About';
import Login from './Login';
import Signup from './Signup';
import Home from './Home';
import Dashboard from './Dashboard';
import Contact from './Contact';
import ContactMessages from './ContactMessages';
import Profile from './profile/Profile';
import Password from "./password/Password";
import Logout from './Logout';
import RequireAuth from './RequireAuth';
import ArticleEditForm from './articles/ArticleEditForm';
import ArticleAddForm from './articles/ArticleAddForm';
import PublishedArticles from './articles/PublishedArticles';
import PublishedArticleShow from './articles/PublishedArticleShow';
import ProfileEditForm from "./profile/ProfileEditForm";
import VideoList from './videos/VideoList';
import Setting from './Setting';
import FourZeroFour from './FourZeroFour';

import UploadImage from './articles/UploadImage';
import ForgotPassword from "./password/ForgotPassword";
import PasswordRecovery from "./password/PasswordRecovery";
import RecoveryConfirmation from "./password/RecoveryConfirmation";
import PublishedArticlePreview from "./articles/PublishedArticlePreview";
import Backup from './admin/Backup'

const BlogRoutes: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    logPageView();
  }, [location]);

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/home" replace />} />
      <Route path="/home" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/about" element={<About />} />
      <Route path="/dashboard" element={<RequireAuth><Dashboard /></RequireAuth>} />
      <Route path="/profile" element={<RequireAuth><Profile /></RequireAuth>} />
      <Route path="/edit-profile" element={<RequireAuth><ProfileEditForm /></RequireAuth>} />

      <Route path="/admin/backup" element={<RequireAuth><Backup /></RequireAuth>} />
      <Route path="/password" element={<Password />} />
      <Route path="/password-recovery/:token" element={<PasswordRecovery />} />
      <Route path="/recovery-confirmation" element={<RecoveryConfirmation />} />

      <Route path="/published-articles" element={<PublishedArticles />}/>
      <Route path="/settings/get_gck" element={<Setting />}/>
      <Route path="/upload-image/:id" element={<UploadImage />}/>
      <Route path="/article/edit/:id" element={<RequireAuth><ArticleEditForm /></RequireAuth>}/>
      <Route path="/article/:id/show" element={<PublishedArticleShow />}/>
      <Route path="/article/:id/preview" element={<PublishedArticlePreview />}/>
      <Route path="/contact" element={<Contact />}/>
      <Route path="/contact/messages" element={<ContactMessages />}/>
      <Route path="/article/new" element={<RequireAuth><ArticleAddForm /></RequireAuth>}/>
      <Route path="/videos" element={<VideoList />}/>
      <Route path="/forgot-password" element={<ForgotPassword />}/>
      <Route path="/logout" element={<Logout />} />
      <Route path="*" element={<FourZeroFour />} />
    </Routes>
  );
};

export default BlogRoutes;
